import React, { useCallback, useEffect, useState } from "react";
import "./Leads.css";
import axios from "axios";
import { AllBookingLeads } from "../../FetchAPI";
import LeadBox from "./LeadBox";
import Sidebar from "../Sidebar";
import DeshbordBreadcrumb from "../Breadcrumb/DeshbordBreadcrumb";
import DeshBoardFooter from "../DeshBoardFooter";
import { useAuth } from "../../../Store/AuthContext";
import { Helmet } from "react-helmet";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function Leads() {
  const { userID, RendomTokenfetch } = useAuth();
  // const [UserLead, Status, msg] = AllserviceLeads(RendomTokenfetch, "5", "0");
  // console.log(UserLead);

  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedService, setSelectedService] = useState("");
  const [error, setError] = useState(null);

  const [UserLead, setUserLead] = useState([]);

  const [loading, setLoading] = useState(false);

  const FetchLeads = useCallback(async () => {
    try {
      setLoading(true);
      const data = await AllBookingLeads(
        RendomTokenfetch,
        "5",
        "0",
        "",
        selectedCategory,
        selectedService
      );
      setUserLead(data);
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, selectedCategory, selectedService]);

  useEffect(() => {
    FetchLeads();
  }, [FetchLeads]);

  const LeadsClearFilter = () => {
    setSelectedCategory("");
    setSelectedService("");
  };

  // if (loading) {
  //   return <PageWithLoader />; // Show the loader while data is being fetched
  // }

  const [currentPage, setCurrentPage] = useState(1);
  const questionsPerPage = 10;
  const totalPages = Math.ceil(UserLead.length / questionsPerPage);
  const indexOfLastQuestion = currentPage * questionsPerPage;
  const indexOfFirstQuestion = indexOfLastQuestion - questionsPerPage;
  const currentLeads = UserLead.slice(
    indexOfFirstQuestion,
    indexOfLastQuestion
  );

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 ||
      i === totalPages ||
      (i >= currentPage - 1 && i <= currentPage + 1)
    ) {
      pageNumbers.push(i);
    } else if (pageNumbers[pageNumbers.length - 1] !== "...") {
      pageNumbers.push("...");
    }
  }

  // Fetch categories on component mount
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    const FetchVendorcatData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}getallcategoryvendor`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setCategories(response.data.catdata || []);
            }
            if (response.data.Status === "0") {
              setCategories([]);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchVendorcatData();
  }, [RendomTokenfetch, userID]);

  // Fetch services when category changes
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("catid", selectedCategory);
    setSelectedService("");
    const FetchVendorServiceData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}allcatservicevendor`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setServices(response.data.servicedata || []);
            }
            if (response.data.Status === "0") {
              setServices([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchVendorServiceData();
  }, [RendomTokenfetch, selectedCategory, userID]);

  const ShowNotfoundlead = (currentLeads) => {
    let ShowLeaddata;
    if (currentLeads.length === 0) {
      ShowLeaddata = (
        <>
          <div className="leadNotfountbox">
            <p>Booking Not Found !</p>
          </div>
        </>
      );
    } else {
      ShowLeaddata = (
        <>
          <div className="whiteBoxOuter">
            <div className="row">
              {currentLeads.length > 0 &&
                currentLeads.map((value, index) => (
                  <LeadBox key={index} leaddata={value} />
                ))}
            </div>
          </div>
        </>
      );
    }
    return ShowLeaddata;
  };

  if (loading) {
    // return <APIDataFetchLoader />;
  }
  if (error) {
    return alert(error);
  }
  return (
    <>
      <Helmet>
          <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb page1={[{ name: "Service Booking" }]} />

        <section className="user-dashboard transaction-history">
          <div className="dashboard-outer dashboardouter">
            <div className="row">
              <div className="col-lg-12">
                <div className="ls-widget">
                  <div className="tabs-box">
                    <div className="widget-title  px-2 py-1 newsvendorfliderheading">
                      <p className="m-0">FILTER BY</p>
                    </div>
                    <div className="widget-content p-3">
                      <form className="was-validated">
                        <div className="row">
                          {/* <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label htmlFor="leadID">Ticket Number</label>
                            <input
                              type="text"
                              className="form-control"
                              name="leadID"
                              value={leadID}
                              onChange={(e) => setleadID(e.target.value)}
                            />
                          </div> */}

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label htmlFor="catID">Service Category</label>
                            <select
                              className="form-control"
                              value={selectedCategory}
                              onChange={(e) =>
                                setSelectedCategory(e.target.value)
                              }
                              required
                            >
                              <option value="">Select Category</option>
                              {categories.map((val) => (
                                <option value={val.id} key={val.id}>
                                  {val.category}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label htmlFor="serviceID">Services</label>
                            <select
                              className="form-control"
                              value={selectedService}
                              onChange={(e) =>
                                setSelectedService(e.target.value)
                              }
                              // disabled={!!selectedService}
                              required
                            >
                              <option value="">Select Service</option>
                              {services.map((value) => (
                                <option value={value.id} key={value.id}>
                                  {value.title}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 text-center mt-3">
                          {/* <button className="theme-btn btn-style-three submitbtn">
                            Submit
                          </button> */}
                          <span
                            className="mx-4 theme-btn btn-style-three submitbtn"
                            onClick={LeadsClearFilter}
                          >
                            Clear Filter
                          </span>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {ShowNotfoundlead(currentLeads)}
          </div>

          {totalPages > 1 && (
            <div className="pagination-controls text-center mt-5">
              <button
                className="pagination-btn"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                ◄
              </button>
              {pageNumbers.map((number, index) => (
                <button
                  key={index}
                  className={`pagination-btn ${
                    number === currentPage ? "active" : ""
                  }`}
                  onClick={() => number !== "..." && setCurrentPage(number)}
                  disabled={number === "..."}
                >
                  {number}
                </button>
              ))}
              <button
                className="pagination-btn"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                ►
              </button>
            </div>
          )}
        </section>
        <div className="deshboard_footer">
          <DeshBoardFooter RendomTokenfetch={RendomTokenfetch} />
        </div>
      </div>
    </>
  );
}
